import React, { useEffect, useState } from "react";
import { IoIosAddCircle } from "react-icons/io";
import Options from "../../components/purchases/Options";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../lib/axios";
import Delete from "../../components/Delete";
import { showCreateForm } from "../../redux/features/purchaseSlice";
import Select from "react-select";
import moment from "moment-jalaali";

function PurchaseList() {
  const [purchases, setPurchases] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [supplierId, setSupplierId] = useState(null);
  const deleteItem = useSelector((state) => state.delete.item);
  const paymentCreateForm = useSelector(
    (state) => state.purchase.paymentCreateForm,
  );
  const [categories, setCategories] = useState([
    { name: "همه", active: true, en: "all" },
    { name: "تصویه شده ها", active: false, en: "balance" },
    { name: "طلبکار", active: false, en: "creditor" },
    { name: "سر رسیده", active: false, en: "overdue" },
  ]);
  const [search, setSearch] = useState("");
  const [records, setRecords] = useState(10);
  const [url, setUrl] = useState(`/api/purchases`);
  const [stocked, setStocked] = useState(2);

  const dispatch = useDispatch();
  useEffect(() => {
    axios
      .get("/api/suppliers/select2")
      .then((data) => {
        setSuppliers(data);
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (!deleteItem.id && !paymentCreateForm) {
      getPurchases();
    }
  }, [
    categories,
    deleteItem,
    records,
    url,
    stocked,
    paymentCreateForm,
    supplierId,
  ]);
  useEffect(() => {
    let delaySearch;
    const handleSearchDelay = () => {
      delaySearch = setTimeout(() => {
        console.log(`Performing search for: ${search}`);
        getPurchases();
      }, 800);
    };
    const handleKeyUp = () => {
      if (delaySearch) {
        clearTimeout(delaySearch);
      }
      handleSearchDelay();
    };
    handleKeyUp();
    return () => {
      clearTimeout(delaySearch);
    };
  }, [search]);

  const getPurchases = () => {
    axios
      .post(url, {
        category: categories.find((row) => row.active === true).en,
        search,
        records,
        stocked,
        supplierId,
      })
      .then((data) => {
        setPurchases(data);
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateCategory = (index) => {
    setCategories((prevCategories) => {
      const updatedCategories = prevCategories.map((row, i) => {
        if (index === i) {
          return { ...row, active: true };
        }
        return { ...row, active: false };
      });

      return updatedCategories;
    });
  };

  return (
    <div>
      <div className="flex flex-col md:flex-row bg-slate-50 border justify-between py-2 px-4">
        <h3>لیست خریداری مواد خام</h3>
        <div className="flex gap-6 ">
          {categories.map((row, index) => (
            <button
              key={index}
              onClick={() => updateCategory(index)}
              className={` rounded-sm  border border-blue-300 px-2 ${
                row.active
                  ? "bg-blue-300 text-gray-700"
                  : "text-blue-300 hover:text-blue-500 hover:border-blue-500 hover:bg-gray-100"
              }`}
              disabled={row.active ? true : false}
            >
              {row.name}
            </button>
          ))}
          <button
            onClick={() => dispatch(showCreateForm())}
            className="flex bg-sky-500 text-white rounded-sm py-1 px-2 hover:bg-sky-700 hover:font-semibold"
          >
            <IoIosAddCircle className="ml-1" size={22} />
            اضافه کردن
          </button>
        </div>
      </div>
      <div className="p-4">
        <div className="flex gap-4 mt-8">
          <select
            onChange={(e) => setRecords(e.target.value)}
            className="ring-1 ring-inset ring-gray-300  mb-3 px-4 py-2 rounded-md"
          >
            <option className="p-0 m-0" value={10}>
              10
            </option>
            <option className="p-0 m-0" value={20}>
              20
            </option>
            <option className="p-0 m-0" value={50}>
              50
            </option>
            <option className="p-0 m-0" value={100}>
              100
            </option>
            <option className="p-0 m-0" value={500}>
              500
            </option>
          </select>
          <select
            onChange={(e) => setStocked(e.target.value)}
            className="ring-1 ring-inset ring-gray-300  mb-3 px-2 py-2 rounded-md"
          >
            <option className="p-0 m-0" value={2}>
              همه
            </option>
            <option className="p-0 m-0" value={0}>
              انبار نشده ها
            </option>
            <option className="p-0 m-0" value={1}>
              انبار شده ها
            </option>
          </select>
          <Select
            placeholder="تامین کننده"
            required
            onChange={(e) => setSupplierId(e ? e.value : null)}
            isClearable={true}
            options={suppliers}
            styles={{
              control: (provided) => ({
                ...provided,
                padding: "0.2rem", // Adjust the padding value as needed
              }),
            }}
            className="w-60 z-0"
          />
          <input
            type="text"
            className="ring-1 ring-inset ring-gray-300  mb-3 px-4 py-2 rounded-md"
            value={search}
            placeholder="جستجو..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <table className="table-auto w-full">
          <thead>
            <tr className="border-y">
              <th className="px-4 py-2 text-start">#</th>
              <th className="px-4 py-2 text-start">سررسید</th>
              <th className="px-4 py-2 text-start">تامین کننده</th>
              <th className="px-4 py-2 text-start">مقدار</th>
              <th className="px-4 py-2 text-start">بیلانس</th>
              <th className="px-4 py-2 text-start">ثبت انبار گردیده؟</th>
              <th className="px-4 py-2 text-start">حالت پرداخت</th>
              <th className="px-4 py-2 text-start">عملیه ها</th>
            </tr>
          </thead>
          <tbody>
            {purchases?.data &&
              purchases?.data.map((row, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-gray-100" : "bg-white"
                  } border`}
                >
                  <td className="px-4 py-2">{row.id}</td>
                  <td
                    className={`px-4 py-2 ${
                      row.balance > 0
                        ? new Date(row.date) < new Date()
                          ? "text-red-500"
                          : "text-black"
                        : "text-green-500"
                    }`}
                  >
                    {moment(row.due_date, "YYYY-M-D").format("jYYYY/jM/jD")}
                  </td>
                  <td className="px-4 py-2">{row.name}</td>
                  <td className="px-4 py-2">
                    {row.total} {row.currency}
                  </td>
                  <td className="px-4 py-2">
                    {row.balance} {row.currency}
                  </td>
                  <td className="px-4 py-2">{row.stocked ? "بلی" : "نخیر"}</td>
                  <td className={`px-4 py-2 text-white`}>
                    {row.balance > 0 ? (
                      <span className="bg-red-400 px-2 rounded-sm">باقی</span>
                    ) : (
                      <span className="bg-green-400 px-2 rounded-sm">
                        {" "}
                        پرداخت شد
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-2">
                    <Options purchase={row} />{" "}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="flex gap-4 justify-end p-4">
          {purchases.links &&
            purchases.links.length > 3 &&
            purchases.links.map((row, index) => (
              <button
                key={index}
                disabled={row.active || row.url === null}
                onClick={() => setUrl(row.url)}
                className={`border py-1 px-3 ${
                  row.active ? "bg-blue-500 text-white" : "hover:bg-gray-300"
                }`}
              >
                <>{row.label}</>
              </button>
            ))}
          {deleteItem.id && <Delete />}
        </div>
      </div>
    </div>
  );
}

export default PurchaseList;
